// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2Lp9U","row":"Node_row__Mcv7u","label":"Node_label__275qo","footer":"Node_footer__vpLpP"};